/**
 * Menu script
 */

class Clinic_FAQ {
    constructor () {
        this.summaries = document.querySelectorAll('summary:not(.pricing-item-title)');
        
        if (this.summaries && this.summaries.length) {
            this.summaries.forEach((summary) => {
                summary.addEventListener('click', () => {
                    this.closeOpenedDetails();
                }, false);
            });
        }
    }

    closeOpenedDetails () {
        this.summaries.forEach((summary) => {
            let detail = summary.parentNode;
            
            if (detail !== this.parentNode) {
                detail.removeAttribute('open');
            }
        });
    }
}